// MODULES
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../app-routing.module';

// LIBRERIAS INSTALADAS
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { LazyLoadImageModule } from 'ng-lazyload-image';

// COMPONENTS
import { NavbarComponent } from '@layout/navbar/navbar.component';
import { FooterComponent } from '@layout/footer/footer.component';
import { LoadingComponent } from '@layout/loading/loading.component';

@NgModule({
  declarations: [NavbarComponent, FooterComponent, LoadingComponent],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    AppRoutingModule,
    NgxPageScrollCoreModule.forRoot(),
  ],
  exports: [NavbarComponent, FooterComponent, LoadingComponent],
})
export class LayoutModule { }
